import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {Modal} from 'app/custom/modal/Modal'
import {useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'
import MyCard from './profile/MyCard'

const StdMenu = () => {
  const {t} = useTranslation()

  const [isShown, setIsShown] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const toggle = useCallback(() => setIsShown((prev) => !prev), [])

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/student/my-profile',
      icon: 'fas fa-user-astronaut',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/student/my-courses',
      icon: 'fas fa-graduation-cap',
      color: '#10b981',
    },
    {
      title: t('LABEL.MY_TRANSCRIPT'),
      to: '/student/my-transcript',
      icon: 'fas fa-medal',
      color: '#f59e0b',
    },
    {
      title: t('LABEL.MY_INVOICES'),
      to: '/student/my-invoices',
      icon: 'fas fa-coins',
      color: '#f43f5e',
    },
    {
      title: t('MEETING.MEETINGS'),
      to: '/student/meetings',
      icon: 'fas fa-video',
      color: '#0ea5e9',
    },
    {
      title: t('LABEL.MY_LETTERS'),
      to: '/student/my-letters',
      icon: 'fas fa-envelope',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.MY_RESOURCE'),
      to: '/student/my-resource',
      icon: 'fas fa-cloud-download-alt',
      color: '#64748b',
    },
    {
      title: t('LABEL.MY_FEEDBACK'),
      to: '/student/my-feedback',
      icon: 'fas fa-star',
      color: '#22c55e',
    },
    {
      title: t('LABEL.CHAT'),
      to: '/student/chat-room',
      icon: 'fas fa-comment-dots',
      color: '#6366f1',
    },
  ]

  const moreMenus = [
    {
      title: t('LABEL.MY_CARD'),
      icon: 'fas fa-id-card',
      color: '#ef4444',
      bgColor: '#fef2f2',
      borderColor: '#ef4444',
      action: toggle,
    },
    {
      title: t('LABEL.MY_DOCUMENTS'),
      to: '/student/my-documents',
      icon: 'fas fa-folder-open',
      color: '#0ea5e9',
      bgColor: '#f0f9ff',
      borderColor: '#0ea5e9',
    },
    {
      title: t('LABEL.MY_NOTES'),
      to: '/student/my-notes',
      icon: 'fas fa-pen-fancy',
      color: '#84cc16',
      bgColor: '#f7fee7',
      borderColor: '#84cc16',
    },
    {
      title: t('LABEL.MY_UMEF'),
      to: '/student/my-umef',
      icon: 'fas fa-landmark',
      color: '#8b5cf6',
      bgColor: '#f5f3ff',
      borderColor: '#8b5cf6',
    },
    {
      title: t('PARENT.PARENT_ACCOUNT'),
      to: '/student/parent',
      icon: 'fas fa-heart',
      color: '#2563eb',
      bgColor: '#eff6ff',
      borderColor: '#2563eb',
    },
  ]

  const renderMenu = (menu: any) => (
    <div
      className='compact-menu-item px-3'
      style={{backgroundColor: `${menu.color}15`, borderColor: menu.color}}
    >
      <div className='compact-icon'>
        <i className={`${menu.icon}`} style={{color: menu.color}}></i>
      </div>
      <div className='menu-text'>
        <span className='menu-title' style={{color: menu.color}}>
          {menu.title}
        </span>
      </div>
      <div className='menu-shine'></div>
    </div>
  )

  const renderDropdownCard = (menu: any) => (
    <div
      className='dropdown-card'
      style={{backgroundColor: menu.bgColor, borderColor: menu.borderColor}}
    >
      <div className='dropdown-icon-wrapper'>
        <i className={`${menu.icon} text-xl`} style={{color: menu.color}}></i>
      </div>
      <div className='dropdown-info'>
        <span className='dropdown-title' style={{color: menu.color}}>
          {menu.title}
        </span>
      </div>
    </div>
  )

  return (
    <div className='modern-compact-menu'>
      <div className='menu-container'>
        {menus.map((menu, index) => (
          <MenuItem key={index} to={menu.to} title={renderMenu(menu)} />
        ))}

        <div onClick={() => setShowMore(!showMore)} className='mt-2'>
          <div className='compact-menu-item more-button' title={t('LABEL.MORE')}>
            <div className='compact-icon more-icon'>
              <i
                className={`fas fa-${
                  showMore ? 'times' : 'plus'
                } text-white text-xl transition-all duration-500 ${showMore ? 'rotate-90' : ''}`}
                style={{color: '#083e5e'}}
              ></i>
            </div>
            <div className='menu-shine'></div>
          </div>
        </div>
      </div>

      {/* MORE MENU */}
      {showMore && (
        <div className='dropdown-panel'>
          <div className='dropdown-grid'>
            {moreMenus.map((menu, index) => {
              const cardContent = renderDropdownCard(menu)

              if (menu.action) {
                return (
                  <div key={index} className='dropdown-item-wrapper' onClick={menu.action}>
                    {cardContent}
                  </div>
                )
              }

              return <MenuItem key={index} to={menu.to} title={cardContent} />
            })}
          </div>
        </div>
      )}

      {/* MODAL */}
      <Modal
        isShown={isShown}
        hide={toggle}
        modalContent={<MyCard />}
        headerText={t('LABEL.MY_CARD')}
      />

      {/* STYLES */}
      <style>{`
        .modern-compact-menu {
          width: 100%;
          font-family: 'Inter', 'Poppins', system-ui, sans-serif;
        }

        .menu-container {
          display: flex;
          flex-wrap: wrap;
        }

        .compact-menu-item {
          position: relative;
          padding: 12px 20px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          overflow: hidden;
          border: 1px solid;
          background: white;
        }

        .compact-menu-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        .compact-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .compact-icon i {
          font-size: 20px !important;
        }

        .compact-menu-item:hover .compact-icon {
          transform: scale(1.1);
        }

        .menu-text {
          display: flex;
          align-items: center;
        }

        .menu-title {
          font-size: 14px;
          font-weight: 600;
          letter-spacing: -0.3px;
          white-space: nowrap;
        }

        .menu-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          transition: left 0.6s ease;
          pointer-events: none;
        }

        .compact-menu-item:hover .menu-shine {
          left: 100%;
        }

        .more-button {
          background: #406e89 !important;
          border-color: #406e89 !important;
        }

        .more-icon i {
          color: #fff !important;
        }

        .more-text {
          color: white !important;
        }

        .more-button:hover .more-text {
          color: #406e89 !important;
        }

        /* DROPDOWN PANEL */
        .dropdown-panel {
          margin-top: 24px;
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          border-radius: 32px;
          padding: 20px;
          box-shadow: 0 30px 50px -20px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.5);
          animation: slideUp 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .dropdown-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding-bottom: 16px;
          margin-bottom: 16px;
          border-bottom: 2px solid #f1f5f9;
          font-size: 18px;
          font-weight: 700;
          color: #0f172a;
        }

        .dropdown-header i {
          font-size: 20px;
          color: #6366f1;
        }

        .dropdown-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 12px;
        }

        /* Make both wrapped div and MenuItem behave the same */
        .dropdown-item-wrapper,
        .dropdown-grid > .MenuItem {
          display: block;
          width: 100%;
        }

        .dropdown-card {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 14px 18px;
          border-radius: 24px;
          transition: all 0.3s ease;
          cursor: pointer;
          border: 1px solid;
        }

        .dropdown-card:hover {
          background: white !important;
          transform: translateX(6px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        .dropdown-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .dropdown-icon-wrapper i {
          font-size: 22px !important;
        }

        .dropdown-card:hover .dropdown-icon-wrapper {
          transform: scale(1.1);
        }

        .dropdown-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .dropdown-title {
          font-size: 14px;
          font-weight: 600;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .menu-container {
            gap: 6px;
          }
          .compact-menu-item {
            padding: 10px 16px;
            gap: 6px;
          }
          .compact-icon i {
            font-size: 18px !important;
          }
          .menu-title {
            font-size: 13px;
          }
        }

        @media (max-width: 680px) {
          .menu-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 5px;
          }
          .compact-menu-item {
            justify-content: center;
          }
          .dropdown-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .compact-menu-item {
            padding: 8px 12px;
            gap: 8px;
          }
          .compact-icon i {
            font-size: 16px !important;
          }
          .menu-title {
            font-size: 12px;
          }
          .dropdown-card {
            padding: 10px 14px;
          }
          .dropdown-icon-wrapper i {
            font-size: 18px !important;
          }
          .dropdown-title {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  )
}

export default StdMenu
